export default "__VITE_ASSET__cKc79ugM__"